// React
import React from "react";
import PropTypes from "prop-types";

// Material-UI components
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

// Icons and Helpers
import CloseIcon from "../../../../../assets/icons/close.svg";

// Custom Components
import Drag from "../../../../DocumentTemplate/NewTemplate/FormComponent/Drag";

// Constants
import { REMOVE_LEVEL, UPDATE_LEVEL } from "../../../CreateNewFolder";

function ApprovalLevel({ approvalLevel = {}, mutationHandler, index = 1 }) {
  return (
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <div
        className="d-flex"
        onClick={(e) => {
          // Prevent the click event from propagating to parent elements
          e.stopPropagation();
          // Your additional click event handling code here
        }}
      >
        <Drag />
        <input
          type="text"
          placeholder={`Enter level ${index + 1} name`}
          maxLength="50"
          value={approvalLevel.levelName}
          onChange={(e) => {
            const payload = {
              id: approvalLevel.id,
              data: {
                levelName: e.target.value,
              },
            };

            mutationHandler(UPDATE_LEVEL, payload);
          }}
          className="mr-4 ml-4 level-name"
        />
        <img
          className="close"
          src={CloseIcon}
          alt="closeIcon"
          onClick={(e) => {
            // Prevent the click event from propagating to parent elements
            e.stopPropagation();
            mutationHandler(REMOVE_LEVEL, approvalLevel.id);
          }}
        />
      </div>
    </AccordionSummary>
  );
}
ApprovalLevel.propTypes = {
  approvalLevel: PropTypes.object.isRequired,
  mutationHandler: PropTypes.func.isRequired,
  index: PropTypes.number,
};

export default ApprovalLevel;
